import { getAuthData } from './auth';

export const GetCurrencyConfig = (state, defaultCurrencyRounding) => (
  state.user.profile
    ? state.swarmConfigData.currency?.[state.user.profile.currency_id]
    : state.swarmConfigData.currency?.[getAuthData()?.currency]
) || {
  rate: 1,
  rounding: defaultCurrencyRounding,
  name: getAuthData()?.currency,
};
